import React, { useRef } from 'react'
import { createPortal } from 'react-dom';
import Activity from '../Activity/Activity';
import NormalMenu from '../NormalMenu/NormalMenu';
import MobileMenuHeader from '../MobileMenuHeader';
import { useMobileLeftSiderSwitch } from '@/store/commonStore';
import { CloseIcon } from '@/componentsUI/Icon';
import { getMobileCenteredShellPortalRoot } from '@/layout/components/mobileCenteredShell/portal';
import './index.less'
const SiderLeftMenu = () => {
    const prefixCls = 'JHJ-sider-left-menu'
    const [drawerVisible, setDrawerVisible] = useMobileLeftSiderSwitch()
    const scrollRef = useRef(null);
    const mobilePanel = drawerVisible ? (
        <div className={`${prefixCls}-mobile`} role="dialog" aria-modal="true">
            <button
                type="button"
                className={`${prefixCls}-mobile-mask`}
                aria-label="Close menu"
                onClick={() => setDrawerVisible(false)}
            />
            <div className={`${prefixCls}-mobile-content`}>
                <div className={`${prefixCls}-mobile-header`}>
                    <MobileMenuHeader title={''} />
                    <button
                        type="button"
                        className={`${prefixCls}-mobile-close`}
                        aria-label="Close menu"
                        onClick={() => setDrawerVisible(false)}
                    >
                        <CloseIcon className={'svg-icon'} />
                    </button>
                </div>
                <Activity className={`pagelayout-activity`} collapsed={false} />
                <NormalMenu className={`pagelayout-normal-menu`} collapsed={false} />
                <div className={`${prefixCls}-mobile-spacer`} />
            </div>
        </div>
    ) : null;
    return (
        <>
            {mobilePanel && createPortal(mobilePanel, getMobileCenteredShellPortalRoot() || document.body)}
        </>
    )
}

export default SiderLeftMenu
